// extracted by mini-css-extract-plugin
export default {"home":"home_home__mPY5+","banner":"home_banner__E7S+O","image":"home_image__aXb52"};